"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const productSearch_1 = require("ts/class/productSearch");
productSearch_1.ProductSearch.init();
